import React from 'react';

import { LogoStyled } from './Logo.styled';
import { BrandLogo } from './BrandLogo';

export const Logo = ({ isMobile, showCampusLogo = true }) => {
  return (
    <LogoStyled isMobile={isMobile}>
      <BrandLogo
        className='catalystLogo'
        isMobile={isMobile}
        showCampusLogo={showCampusLogo}
      />
    </LogoStyled>
  )
}
